<template lang="pug">
div(style="display: contents")
  BriqButton(variant="secondary" class="briq-button" ref="viewAuditTrail" @click="toggleAuditTrail()") View logs
  BriqDialog(ref="closeAuditTrailDialog" @close="toggleAuditTrail()" v-if="showAuditTrailModal" dialogSize="briq-dialog-extra-large")
    h2 Audit trail
    .spinner(v-if="isFetching") 
      Spinner
    .audit-trail-tabs(v-if="!isFetching && !noData") 
      .audit-trail-tab(v-if="shouldTabBeShown(auditTrail)" :class="isTabActive('auditTrail')" @click="makeTabActive('auditTrail')") Audit Trail
      .audit-trail-tab(v-if="shouldTabBeShown(userAuditTrail)" :class="isTabActive('userAuditTrail')" @click="makeTabActive('userAuditTrail')") User Audit Trail
      .audit-trail-tab(v-if="shouldTabBeShown(objectLog)" :class="isTabActive('objectLog')" @click="makeTabActive('objectLog')") Object Log
      .audit-trail-tab(v-if="shouldTabBeShown(apiLog)" :class="isTabActive('apiLog')" @click="makeTabActive('apiLog')") Api Log
      .audit-trail-tab(v-if="shouldTabBeShown(messageLog)" :class="isTabActive('messageLog')" @click="makeTabActive('messageLog')") Message Log
      .audit-trail-tab(v-if="shouldTabBeShown(timeslotProvenance)" :class="isTabActive('timeslotProvenance')" @click="makeTabActive('timeslotProvenance')") Timeslot Provenance
      .audit-trail-tab(v-if="shouldTabBeShown(metaData)" :class="isTabActive('metaData')" @click="makeTabActive('metaData')") Metadata
      .audit-trail-tab(v-if="shouldTabBeShown(objectErrors)" :class="isTabActive('objectErrors')" @click="makeTabActive('objectErrors')") Object Errors
    .logs-table(v-if="!isFetching && !noData")
      AuditTrailTable(v-if="isTabActive('auditTrail')" :logData="auditTrail")
      AuditTrailTable(v-if="isTabActive('userAuditTrail')" :logData="userAuditTrail")
      ApiLogTable(v-if="isTabActive('apiLog')" :logData="apiLog")
      TimeslotProvenanceTable(v-if="isTabActive('timeslotProvenance')" :logData="timeslotProvenance")
      MetaDataTable(v-if="isTabActive('metaData')" :logData="metaData")
      ObjectLogTable(v-if="isTabActive('objectLog')" :logData="objectLog")
      MessageLogTable(v-if="isTabActive('messageLog')" :logData="messageLog")
      ObjectErrorTable(v-if="isTabActive('objectErrors')" :logData="objectErrors")
    div(v-if="noData && !isFetching") No data 
</template>

<script>
import Spinner from '@v/components/Spinner.vue'
import AuditTrailTable from '@v/components-global/BriqViewAuditTrail/AuditTrailTable.vue'
import ApiLogTable from '@v/components-global/BriqViewAuditTrail/ApiLogTable.vue'
import TimeslotProvenanceTable from '@v/components-global/BriqViewAuditTrail/TimeslotProvenanceTable.vue'
import MetaDataTable from '@v/components-global/BriqViewAuditTrail/MetaDataTable.vue'
import ObjectLogTable from '@v/components-global/BriqViewAuditTrail/ObjectLogTable.vue'
import MessageLogTable from '@v/components-global/BriqViewAuditTrail/MessageLogTable.vue'
import ObjectErrorTable from '@v/components-global/BriqViewAuditTrail/ObjectErrorTable.vue'

export default {
  name: 'BriqViewAuditTrail',
  components: {
    Spinner,
    AuditTrailTable,
    ApiLogTable,
    TimeslotProvenanceTable,
    MetaDataTable,
    ObjectLogTable,
    MessageLogTable,
    ObjectErrorTable,
  },
  props: {
    objectType: {
      type: String,
      required: true,
    },
    objectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showAuditTrailModal: false,
      isFetching: false,
      auditTrail: [],
      userAuditTrail: [],
      objectLog: [],
      apiLog: [],
      messageLog: [],
      timeslotProvenance: [],
      metaData: [],
      objectErrors: [],
      activeTab: 'auditTrail',
    }
  },
  computed: {
    noData() {
      return (
        !this.shouldTabBeShown(this.auditTrail) &&
        !this.shouldTabBeShown(this.userAuditTrail) &&
        !this.shouldTabBeShown(this.objectLog) &&
        !this.shouldTabBeShown(this.apiLog) &&
        !this.shouldTabBeShown(this.timeslotProvenance) &&
        !this.shouldTabBeShown(this.metaData) &&
        !this.shouldTabBeShown(this.objectErrors) &&
        !this.shouldTabBeShown(this.messageLog)
      )
    },
  },
  methods: {
    shouldTabBeShown(data) {
      return data?.length > 0
    },
    makeTabActive(tab) {
      this.activeTab = tab
    },
    isTabActive(tab) {
      return this.activeTab === tab ? 'audit-trail-tab-active' : ''
    },
    toggleAuditTrail() {
      this.showAuditTrailModal = !this.showAuditTrailModal

      if (this.showAuditTrailModal) this.getAuditTrailData()
    },
    async getAuditTrailData() {
      this.isFetching = true
      try {
        const response = await this.$apiClient.get(`logs/${this.objectType}/${this.objectKey}`)
        this.auditTrail = this.addFlagShowDetailsFlag(response.data.AuditTrail)
        this.userAuditTrail = this.addFlagShowDetailsFlag(response.data.UserAuditTrail)
        this.objectLog = this.addFlagShowDetailsFlag(response.data.ObjectLog)
        this.apiLog = this.addFlagShowDetailsFlag(response.data.ApiLog)
        this.messageLog = this.addFlagShowDetailsFlag(response.data.MessageLog)
        this.timeslotProvenance = this.addFlagShowDetailsFlag(response.data.TimeslotProvenance)
        this.metaData = this.addFlagShowDetailsFlag(response.data.MetaData)
        this.objectErrors = this.addFlagShowDetailsFlag(response.data.ObjectErrors)

        this.isFetching = false
      } catch (e) {
        this.error = e
        const message = 'There was a problem: ' + this.error.message
        this.error = message
        this.isFetching = false
        this.$notifyError(message)
      }
    },
    addFlagShowDetailsFlag(logData) {
      return logData
        ? logData.map(x => {
            x.showDetals = false
            return x
          })
        : []
    },
  },
}
</script>

<style scoped lang="stylus">
.spinner
  position absolute
  top 50%
  left 50%

.logs-table
  height 70vh
  overflow-y scroll

.audit-trail-tabs
  display flex
  justify-content space-around
  margin 20px 0px 20px 0px
  border 1px solid #EFF3F7
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1)

  .audit-trail-tab
    width 100%
    cursor pointer
    text-align center
    text-transform uppercase
    font-weight 500
    padding-top 20px

  .audit-trail-tab-active
    border-bottom 3px solid #008ce8
    color #008ce8

.briq-button
  margin 0px 5px 0px 5px
</style>
